<template>
  <div class="verify-contain">
    <div v-if="this.statusUrl == 'Try_Again'" >
      <div class="verify-img">
        <img src="../../src/assets/fail.png" alt="fail" class="img-icon">
      </div>
      <p class="header-text">Please tap again</p>
      <p class="info-text">Something went wrong</p>
    </div>
    <div v-else-if="this.statusUrl == 'NullData'">
      <div class="verify-img">
        <img src="../../src/assets/fail.png" alt="fail" class="img-icon">
      </div>
      <p class="header-text">No data</p>
    </div>
    <div v-else-if="this.statusUrl == 'NullPublicData'">
      <div class="verify-img">
        <img src="../../src/assets/fail.png" alt="fail" class="img-icon">
      </div>
      <p class="header-text">Restricted Information</p>
    </div>
    <div v-else-if="this.statusUrl == 'TimeOut'">
      <div class="verify-icon">
        <fa-icon icon="fa fa-circle-exclamation" />
      </div>
      <p class="header-text">Please tap again</p>
      <p class="info-text">Session is expired</p>
    </div>
    <div v-else-if="this.statusUrl == 'Verify'">
      <p class="verify-text"></p>
      <div class="loader-spin"></div>
      <p class="header-text">Please wait</p>
    </div>
    <div v-else-if="this.statusUrl == 'Waiting'">
      <div class="verify-icon">
        <fa-icon icon="fa fa-circle-exclamation" />
      </div>
      <p class="header-text">Please tap again</p>
      <p class="info-text">Loading is taking longer than expected</p>
    </div>
    <div v-else-if="this.statusUrl == 'ReadUser'">
      <p class="load-text"></p>
      <div class="loader-spin"></div>
      <p class="header-text">Please wait</p>
    </div>
    <div v-else-if="this.statusUrl == 'CheckOwner'">
      <p class="login-text"></p>
      <!-- <div class="loader">
        <div class="loaderBar"></div>
      </div> -->
      <div class="loader-spin"></div>
      <p class="header-text">Please wait</p>
    </div>
    <div v-else-if="this.statusUrl == 'Save'">
      <p class="save-text"></p>
      <div class="loader-line">
        <div class="loade-wrap">
          <div class="loader-dot"></div>
          <div class="loader-dot"></div>
          <div class="loader-dot"></div>
          <div class="loader-dot"></div>
          <div class="loader-dot"></div>
          <div class="loader-dot"></div>
          <div class="loader-dot"></div>
        </div>
        <p class="wait-text">Please wait</p>
      </div>
    </div>
    <div v-else-if="this.statusUrl == 'Ready'">
      <div class="verify-img">
        <img src="../../src/assets/ready.png" alt="Ready" class="img-icon">
      </div>
      <p class="header-text">Ready to use</p>
      <p class="picture-text">Your profile image may take a few minutes to be updated.</p>
    </div>
    <div v-else-if="this.statusUrl == 'LoginSucess'">
      <div class="verify-img">
        <img src="../../src/assets/ready.png" alt="Ready" class="img-icon">
      </div>
      <p class="header-text">Login Success</p>
    </div>
    <div v-else-if="this.statusUrl == 'Owned'">
      <div class="verify-img">
        <img src="../../src/assets/fail.png" alt="Ready" class="img-icon">
      </div>
      <p class="header-text">This card is already owned</p>
      <div class="btn" @click="SignOut">
        <a target="_self"
          rel="noopener noreferrer"
          aria-expanded="false">
        LOG OUT</a>
      </div>
    </div>
  </div>
</template>

<script>
import auths from '../store/auth/auths';
import actions from '../store/user/actions';

export default {
  name: 'VerifyURL',
  props: {
    status: String
  },

  data() {
    return {
      statusUrl: '',
      newstatus: '',
      authen_countdown: 0,
      timerCount: 30,
      timerEnabled: true,
    }
  },
  watch: {
    timerEnabled(value) {
      console.log("timerEnabled");
      if (value) {
        setTimeout(() => {
          console.log("timerEnabled1");
          console.log(this.timerCount);
          this.timerCount--;
        }, 1000);
      }
    },

    timerCount: {
      handler(value) {
        if (value > 0 && this.timerEnabled) {
          setTimeout(() => {
            console.log("handler");
            console.log(this.timerCount);
            this.timerCount--;
            if(this.timerCount == 0)
            {
              this.$emitter.emit('countdown');
              actions.actionErrorMessage = "The loading time exceeds 30 seconds.";
            }
          }, 1000);
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.statusUrl = this.status;
    console.log(this.statusUrl);

    if(this.statusUrl == "Verify")
    {
      this.timerEnabled = true;
    }
    else
    {
      console.log("Stop");
      this.timerEnabled = false;
    }
  },
  methods: {
    async SignOut() {
      this.account = null;
      var authStatus = await auths.SignOut();
      if(authStatus == true){
        this.$emitter.emit('logout');
        console.log("Complete Logout");
      }

      this.$store.commit('setAccessToken', null);
    },
  }
  
}
</script>

<style>
.verify-contain {
  width: 100%;
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.verify-icon {
  color: white;
  font-size: 3rem;
  text-align: center;
  margin-bottom: 1rem;
}
.verify-img {
  color: white;
  text-align: center;
  margin-bottom: 1em;
}
.img-icon {
  height: 4rem;
}
.wait-text {
  color: #3cd2ef;
  top: 20%;
  margin: 0;
  font-size: 1.5em;
  font-weight: bold;
  text-align: center;
  margin-bottom: 0.5em;
  padding-top: 25%;
}
.header-text {
  color: #3cd2ef;
  margin: 0;
  font-size: 1.5em;
  font-weight: bold;
  text-align: center;
  margin-bottom: 0.5em;
}
.picture-text {
  color: #c5c8c9;
  margin: 0;
  font-size: 0.6em;
  text-align: center;
  padding-left: 2rem;
  padding-right: 2rem;
  margin-bottom: 0.5em;
}
.info-text {
  color: white;
  margin: 0;
  font-size: 1rem;
  text-align: center;
}
.loader { 
  width: 50%; 
  margin: 0 auto;
  border-radius: 1rem;
  border: 1em solid transparent;
  position: relative;
  padding: 0.2rem;
  margin-bottom: 2rem;
  margin-top: 0.5rem;
}
.loader:before {
  content: '';
  border: 0.1rem solid #fff; 
  border-radius: 1rem;
  position: absolute;
  top: -4px; 
  right: -4px; 
  bottom: -4px; 
  left: -4px;
}
.loader .loaderBar { 
  position: absolute;
  border-radius: 1rem;
  top: 0;
  right: 100%;
  bottom: 0;
  left: 0;
  background: #fff; 
  width: 0;
  animation: borealisBar 2s linear infinite;
}
@keyframes borealisBar {
  0% {
    left: 0%;
    right: 100%;
    width: 0%;
  }
  10% {
    left: 0%;
    right: 75%;
    width: 25%;
  }
  90% {
    right: 0%;
    left: 75%;
    width: 25%;
  }
  100% {
    left: 100%;
    right: 0%;
    width: 0%;
  }
}
.progress {
  left: 70%;
  height: 10px;
  width: 60%;
  border: 6px solid #ffffff;
  border-radius: 15px;
  margin-bottom: 4rem;
  transform: translate(30%, 50%);
}
.progress .color {
  position: absolute;
  background-color: #75d6f3;
  width: 0px;
  height: 10px;
  border-radius: 5px;
  animation: progres 4s infinite linear;    
}
@keyframes progres{
  0%{
    width: 0%;
  }
  25%{
    width: 50%;
  }
  50%{
    width: 75%;
  }
  75%{
    width: 85%;
  }
  100%{
    width: 100%;
  }
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.loader-spin {
  border: 16px solid #e7e7e7;;
  border-radius: 50%;
  border-top: 16px solid #3cd2ef;
  width: 80px;
  height: 80px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
  margin: 1rem auto;
}
.loader-line {
  width: 250px;
  padding-top: 1.5rem;
  margin: auto;
}
.loader-wrap {
  padding-top: 20%;
}
.loader-dot {
  animation: loader ease-in-out 3s infinite;
  height: 20px;
  width: 20px;
  border-radius: 100%;
  background-color: #00b4fc;
  position: absolute;
  border: 2px solid white;
}
.loader-dot:first-child {
  background-color: #bfeff8;
  animation-delay: 0.5s;
}
.loader-dot:nth-child(2) {
  background-color: #9defff;
  animation-delay: 0.4s;
}    
.loader-dot:nth-child(3) {
  background-color: #7fe7fc;
  animation-delay: 0.3s;
}
.loader-dot:nth-child(4) {
  background-color: #3cd2ef;
  animation-delay: 0.2s;
}
.loader-dot:nth-child(5) {
  background-color: #21c9fc;
  animation-delay: 0.1s;
}
.loader-dot:nth-child(6) {
  background-color: #00b4fc;
  animation-delay: 0s;
}
.save-text {
  color: white;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
.save-text:after {
  content: "Saving";
  animation: saving-text 2s infinite;
} 
.login-text {
  color: white;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
.login-text:after {
  content: "Logging in";
  animation: loging-text 2s infinite;
} 
.verify-text {
  color: white;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
.verify-text:after {
  content: "Verifying";
  animation: verifying-text 2s infinite;
} 
.load-text {
  color: white;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
.load-text:after {
  content: "Loading";
  animation: loading-text 2s infinite;
} 
@keyframes loader {
  15% {
    transform: translateX(0);
  }
  45% {
    transform: translateX(230px);
  }
  65% {
    transform: translateX(230px);
  }
  95% {
    transform: translateX(0);
  }
}
@keyframes saving-text {
  0% {
    content: "Saving";
  }
  25% {
    content: "Saving.";
  }
  50% {
    content: "Saving..";
  }
  75% {
    content: "Saving...";
  }
}
@keyframes loging-text {
  0% {
    content: "Logging in";
  }
  25% {
    content: "Logging in.";
  }
  50% {
    content: "Logging in..";
  }
  75% {
    content: "Logging in...";
  }
}
@keyframes verifying-text {
  0% {
    content: "Verifying";
  }
  25% {
    content: "Verifying.";
  }
  50% {
    content: "Verifying..";
  }
  75% {
    content: "Verifying...";
  }
}
@keyframes loading-text {
  0% {
    content: "Loading Data";
  }
  25% {
    content: "Loading Data.";
  }
  50% {
    content: "Loading Data..";
  }
  75% {
    content: "Loading Data...";
  }
}
</style>